import { getEverLoggedIn } from 'dibs-cookie-jar';
import * as tracking from 'dibs-tracking';
import { PAGE_TYPE, BROWSE_TYPES } from 'dibs-constants/exports/pageTypes';
import { gaLabels } from '../../authModal/postAuth/constants';
import { VisitCountModel } from 'dibs-visit-tracking/exports/visitCountModel';
import {
    KEY_REG_PROMPT_COUNT,
    KEY_LAST_REG_PROMPT_SESSION,
    REG_PROMPT_SESSION,
    KEY_SINCE_REG_PROMPT,
} from 'dibs-visit-tracking/exports/visitCountConstants';
import authModalLoader from '../../utils/AuthModalLoader';
import * as postAuthLoader from './helpers/postAuthLoader';
import { canVisitorBePromptedLogin } from './helpers/canVisitorBePromptedLogin';
import { wasUserRedirectedByEmailLoginLink } from './helpers/wasUserRedirectedByEmailLoginLink';
import { wasSemRegistrationShown } from './semRegistration/semRegistrationPrompt';

const MODAL_LIMIT = 3;

const handleConsecutiveModals = ({ visitCountModel }) => {
    const sessionVisitCount = visitCountModel.get('sessionVisitCount');
    const lastRegPromptSession = visitCountModel.get(KEY_LAST_REG_PROMPT_SESSION);

    const isCorrectSession = sessionVisitCount >= lastRegPromptSession + REG_PROMPT_SESSION;
    const isModalLimitReached = visitCountModel.get(KEY_REG_PROMPT_COUNT) === MODAL_LIMIT;

    if (
        //prompt consecutive modals only for unregistered users
        !getEverLoggedIn(document.cookie) &&
        isCorrectSession &&
        !isModalLimitReached &&
        //prevents cases when modal is blcoked for more than one session to be ignored
        visitCountModel.get('session') > visitCountModel.get('regPromptLimit')
    ) {
        visitCountModel.set('regPromptLimit', visitCountModel.get('session'));
        visitCountModel.save();
    }
};

/**
 * Should modal be prompted
 * @param {boolean}
 */
const shouldPromptLoginRegistration = visitCountModel => {
    const wasRedirectedByEmailLoginLink = wasUserRedirectedByEmailLoginLink();

    return (
        !wasRedirectedByEmailLoginLink &&
        visitCountModel.get('session') === visitCountModel.get('regPromptLimit')
    );
};

const canAutoPromptUser = () => {
    const visitCountModel = new VisitCountModel();

    handleConsecutiveModals({ visitCountModel });

    const isModalBlocked = !canVisitorBePromptedLogin() || wasSemRegistrationShown();
    const shouldOpenModal = shouldPromptLoginRegistration(visitCountModel);
    if (shouldOpenModal && !isModalBlocked) {
        return true;
    } else if (shouldOpenModal && isModalBlocked) {
        visitCountModel.increment('regPromptLimit');
        visitCountModel.save();
        return false;
    } else {
        return false;
    }
};

/**
 * prompts visitor to register if it's due
 * @return {boolean} true if login prompted
 */
const openLoginModal = () => dispatch => {
    const flow = authModalLoader.constants.PAGEVIEW_LIMIT_FLOW;
    const ga = {
        label: gaLabels.PAGEVIEW_LIMIT_REACHED,
    };

    const visitCountModel = new VisitCountModel();
    visitCountModel.increment(KEY_REG_PROMPT_COUNT);
    visitCountModel.set(KEY_LAST_REG_PROMPT_SESSION, visitCountModel.get('sessionVisitCount'));
    visitCountModel.set(KEY_SINCE_REG_PROMPT, 0);
    visitCountModel.save();

    tracking.trackEvent({
        category: 'promo interaction',
        action: 'auto modal displayed',
        label: 'auto pageview',
    });

    if (!getEverLoggedIn(document.cookie)) {
        postAuthLoader.autoPromptRegistration({ flow, launchOrigin: ga.label });
    } else {
        authModalLoader.show({
            action: authModalLoader.constants.LOGIN,
            flow,
            ga,
            fireEntryGa: true,
        });
    }
    dispatch({ type: 'noop' });
};

/**
 * Checks condition for auto prompt user.
 * Opens modal if condition is satisfied.
 * Condition:
 * page view >= 2,
 * home / browse / creator / pdp (not print) page type,
 * page is not loaded from EmailTokenLogin email
 * User is not logged in and AuthModal is not opened,
 * on every @param SESSIONS_COUNT session(@param {visitCountModel.get('sessionVisitCount')}) until @param {localStorage.getItem(KEY_REG_PROMPT_COUNT)} === @param MODAL_LIMIT .
 *
 * @return {Promise}
 */
const loginPromptRule = function loginPromptRule() {
    return Promise.resolve(canAutoPromptUser());
};

export default {
    name: 'loginPrompt',
    rule: loginPromptRule,
    action: openLoginModal,
    allowedPageTypes: [
        PAGE_TYPE.HOME,
        PAGE_TYPE.CREATOR,
        PAGE_TYPE.DEALER,
        PAGE_TYPE.PDP,
        PAGE_TYPE.SEARCH,
        ...BROWSE_TYPES,
    ],
    priority: 250,
};
